
import { Button } from "@/components/ui/button";
import { Avatar, AvatarImage } from "@/components/ui/avatar";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-[#0E1116] border-t border-white/10 pt-16 pb-8 relative overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Logo and description */}
          <div>
            <div className="flex items-center mb-6">
              <Avatar className="w-10 h-10 mr-3">
                <AvatarImage src="/lovable-uploads/091c7cd2-d92b-4426-b527-fbbaa0213fa9.png" alt="PopCoin logo" />
              </Avatar>
              <h3 className="text-2xl font-bold text-white">$POP</h3>
            </div>
            <p className="text-gray-400 mb-6">
              The only Solana meme coin with a 2nd Amendment indulging otter baby.
            </p>
            <p className="text-gray-500 text-sm">
              © 2025 PopCoin. All rights reserved.
            </p>
          </div>
          
          {/* Links */}
          <div>
            <h4 className="text-lg font-bold text-white mb-6">Pop's Hideouts</h4>
            <div className="flex flex-col space-y-4">
              <a href="#" className="text-gray-400 hover:text-orange-400 transition-colors inline-flex items-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-2">
                  <path d="M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z"></path>
                </svg>
                X / Twitter
              </a>
              <a href="#" className="text-gray-400 hover:text-orange-400 transition-colors inline-flex items-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-2">
                  <circle cx="12" cy="12" r="10"></circle>
                  <circle cx="12" cy="12" r="3"></circle>
                  <path d="M12 19v.01"></path>
                  <path d="M12 5v.01"></path>
                  <path d="M19 12h.01"></path>
                  <path d="M5 12h.01"></path>
                  <path d="M14 7l-4 10"></path>
                </svg>
                Discord
              </a>
              <a href="#" className="text-gray-400 hover:text-orange-400 transition-colors inline-flex items-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-2">
                  <path d="M21.5 12a9.5 9.5 0 1 1-9.5-9.5 9.46 9.46 0 0 1 9.5 9.5v0Z"></path>
                  <path d="m12 7.3 1.3 3.9h4.1l-3.3 2.4 1.3 3.9-3.4-2.4-3.4 2.4 1.3-3.9-3.3-2.4h4.1z"></path>
                </svg>
                Telegram
              </a>
            </div>
          </div>
          
          {/* Documents */}
          <div>
            <h4 className="text-lg font-bold text-white mb-6">Docs</h4>
            <div className="space-y-4">
              <Link to="/whitepaper" className="inline-block">
                <Button variant="outline" className="border-orange-500/20 hover:border-orange-500/60 hover:bg-orange-500/10 text-gray-300">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-2 text-orange-400">
                    <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"></path>
                    <polyline points="14 2 14 8 20 8"></polyline>
                  </svg>
                  Whitepaper
                </Button>
              </Link>
              
              <Link to="/ocean-outlaw-fund" className="inline-block">
                <Button variant="outline" className="border-orange-500/20 hover:border-orange-500/60 hover:bg-orange-500/10 text-gray-300">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-2 text-orange-400">
                    <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"></path>
                    <polyline points="14 2 14 8 20 8"></polyline>
                  </svg>
                  Ocean Outlaw Fund
                </Button>
              </Link>
            </div>
          </div>
        </div>
        
        <div className="mt-16 pt-8 border-t border-white/10 text-center">
          <p className="text-orange-400 font-handwriting text-xl">– Pop the Otter</p>
        </div>
      </div>
      
      {/* Wave effect at bottom */}
      <div className="absolute bottom-0 left-0 right-0 h-4 bg-gradient-to-r from-orange-500/10 via-orange-500/30 to-orange-500/10"></div>
      
      {/* Decorative elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-orange-500/5 rounded-full blur-3xl -z-10"></div>
    </footer>
  );
};

export default Footer;
